<template>
  <template v-if="user != null">
    <template v-if="deleteResponse == null">
      <template v-if="user.errors == null">
        <Delete v-bind:data="user" @deleteEvent="showMessage"/>
      </template>
      <template v-else>
        <DeleteNotAllowed v-bind:data="user"/>
      </template> 
    </template>
    <template v-else>
      <Message v-bind:response="deleteResponse"/> 
    </template>             
    </template>    
    <template v-else>
      <Verify @userEvent="userAccount"/>  
</template>
</template>

<script>
import Delete from './Delete';
import DeleteNotAllowed from './DeleteNotAllowed';
import Verify from './Verify';
import Message from './Message';
localStorage.removeItem("token");

export default {
  name: 'Home',
  
   components: {
   Delete,
   DeleteNotAllowed,
   Verify,
   Message
  },

  data() {
    return {
      user: null,
      deleteResponse: null
    }
  },
  methods: { 
    userAccount(user){
    this.user = user;
  },

  showMessage(response){
    this.deleteResponse = response;
  }
  } 
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

